import React from "react";
import { Skeleton } from "@progress/kendo-react-indicators";

/**
 * DKNSkeleton — Daikin design system skeleton placeholder.
 * Wraps Kendo Skeleton with project defaults.
 *
 * Props:
 *   shape    "text" | "rectangle" | "circle"  (default: "text")
 *   width    number | string
 *   height   number | string
 *   style    CSSProperties
 *
 * Convenience shorthands:
 *   <DKNSkeleton shape="circle" width={40} height={40} />
 *   <DKNSkeleton shape="text" width="60%" height={16} />
 *   <DKNSkeleton shape="rectangle" width="100%" height={120} />
 */
const DKNSkeleton = ({
  shape = "text",
  width,
  height,
  className = "",
  style,
  ...rest
}) => {
  return (
    <Skeleton
      shape={shape}
      className={`dkn-skeleton ${className}`}
      style={{ width, height, ...style }}
      {...rest}
    />
  );
};

export default DKNSkeleton;
